const PERMISSION_ERROR_MESSAGES = {
  USER_ROLES_PERMISSION_REQUIRED:
    "You can view this profile, but you need Manage user roles permission to change roles or permissions. Ask an owner or administrator to update your access.",
  REWARDS_PROGRAM_PERMISSION_REQUIRED:
    "Rewards are not available for your role. Ask an owner or manager to turn on View rewards program if you need it.",
  GIFT_CARDS_MANAGE_PERMISSION_REQUIRED:
    "Gift cards are not available for your role. Ask an owner or manager to turn on Manage gift cards if you need it.",
  EMAIL_OPTOUT_ACCESS_REQUIRED:
    "Email preferences are not available for your role yet. Ask an owner or manager to turn on Manage email opt-outs and preferences if you need it.",
  APPOINTMENT_OPTIONS_PERMISSION_REQUIRED:
    "Appointment options are not available for your role. Ask an owner or manager to turn on Appointment options if you need them.",
  MAINTENANCE_PERMISSION_REQUIRED:
    "Maintenance & Cleaning is not available for your role. Ask an owner or manager to turn on Maintenance & Cleaning if you need it.",
  INVENTORY_PERMISSION_REQUIRED:
    "Inventory is not available for your role. Ask an owner or manager to turn on Inventory if you need it.",
  CASH_DRAWER_PERMISSION_REQUIRED:
    "Cash drawer is not available for your role. Ask an owner or manager to turn on Cash drawer if you need it.",
  WALKIN_QUEUE_PERMISSION_REQUIRED:
    "The walk-in queue is not available for your role. Ask an owner or manager to turn on Walk-in queue slider if you need it.",
  STAFF_UPDATE_PERMISSION_REQUIRED:
    "Updating staff information is not available for your role. Ask an owner or manager to turn on Update Staff if you need it.",
  STAFF_USES_TIME_CLOCK_PERMISSION_REQUIRED:
    "Changing Uses Time Clock is not available for your role. Ask an owner or manager to turn it on if you need it.",
  STAFF_SHOW_ONLINE_BOOKING_PERMISSION_REQUIRED:
    "Changing Show in Online Booking is not available for your role. Ask an owner or manager to turn it on if you need it.",
  NotAuthorizedToManageGiftCards:
    "Gift cards are not available for your role. Ask an owner or manager to turn on Manage gift cards if you need it.",
  LAST_OWNER_REQUIRED:
    "At least one active owner must remain on the salon account.",
  USER_NOT_IN_SALON:
    "This user is not currently linked to this salon.",
  PrimaryOwnerMembershipCannotBeModified:
    "The primary owner account is protected and cannot be changed here.",
};

function normalizeDetail(detail) {
  return String(detail || "").trim();
}

export function formatPermissionError(err, fallback) {
  const rawDetail =
    typeof err === "string"
      ? err
      : err?.response?.data?.detail || err?.detail || err?.message || "";
  const detail = normalizeDetail(rawDetail);

  if (!detail) {
    return fallback;
  }

  if (PERMISSION_ERROR_MESSAGES[detail]) {
    return PERMISSION_ERROR_MESSAGES[detail];
  }

  if (detail === "Primary owner membership cannot be modified") {
    return PERMISSION_ERROR_MESSAGES.PrimaryOwnerMembershipCannotBeModified;
  }

  if (detail === "Not authorized to manage gift cards") {
    return PERMISSION_ERROR_MESSAGES.NotAuthorizedToManageGiftCards;
  }

  if (/^[A-Z0-9_]+$/.test(detail)) {
    return fallback;
  }

  return detail;
}
